import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../axiosinterceptor';

const initialState = {
    workflowCount: {
        codesCountsData: {},
        codesCountsLoading: false,
        codesCountsError: null
    },

    codingAllocationCount: {
       unassigned: 0,
       forAudited: 0,
       loading: false,
       error: null,
    },
};

export const getWorkflowsCountData = createAsyncThunk(
  '/getWorkflowsCountData',
  async(payload, {fulfillWithValue, rejectWithValue}) => {
    try{
      const response = await axiosInstance.get('/get_him_workspace');
      if(response.data) {
        return fulfillWithValue(response.data)
      }
      // return data; 
    }
    catch(error) {
      console.error('Error fetching episodes:', error);
      return rejectWithValue(error.response?.data?.message || error.message || "No data found");
      // throw error;
    }
  }
)

export const getUnassignedCount = createAsyncThunk(
  "/getUnassignedCount",
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/acs_coding_allocation_count"
      );
      if (response.data.data) {
        return fulfillWithValue(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching UnAssigned Count:', error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found"
      );
    }
  }
);

// export const getForAuditedCount = createAsyncThunk(
//   "/getForAuditedCount",
//   async (_, { fulfillWithValue, rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.get(
//         "/san_episodes_audited_speciality_filter"
//       );
//       if (response.data) {
//         return fulfillWithValue(response.data);
//       }
//     } catch (error) {
//       console.error('Error fetching UnAssigned Count:', error);
//       return rejectWithValue(
//         error.response?.data?.message || error.message || "No data found"
//       );
//     }
//   }
// );



const codeWorkflowSlicer = createSlice({
  name: "codeWorkflowSlicer",
  initialState,
  reducers: {
  
  },
  extraReducers: (builder) => builder
.addCase(getWorkflowsCountData.pending, (state) => {
    state.workflowCount.codesCountsLoading = true;
    state.workflowCount.codesCountsError = null;
  }).addCase(getWorkflowsCountData.fulfilled, (state,action) => {
    state.workflowCount.codesCountsLoading = false;
    state.workflowCount.codesCountsData = action.payload;
  }).addCase(getWorkflowsCountData.rejected, (state, action) => {
    state.workflowCount.codesCountsLoading = false;
    state.workflowCount.codesCountsError = action.payload;
  })
  // Unassigned
    .addCase(getUnassignedCount.pending, (state) => {
         state.codingAllocationCount.loading = true;
         state.codingAllocationCount.error = null;   
    })
    .addCase(getUnassignedCount.fulfilled, (state, action) => {
       state.codingAllocationCount.loading = false;
       state.codingAllocationCount.unassigned =
       action.payload?.unassigned_count || 0;
       state.codingAllocationCount.forAudited =
        action.payload?.for_audit_count || 0;
    })
    .addCase(getUnassignedCount.rejected, (state, action) => {
        state.codingAllocationCount.loading = false;
        state.codingAllocationCount.error = action.payload;
    })

    // For Audited
    // .addCase(getForAuditedCount.pending, (state) => {
    //   state.codingAllocationCount.forAudited.loading = true;
    // })
    // .addCase(getForAuditedCount.fulfilled, (state, action) => {
    //   state.codingAllocationCount.forAudited.loading = false;
    //   state.codingAllocationCount.forAudited.count = action.payload?.for_audited;
    // })
    // .addCase(getForAuditedCount.rejected, (state, action) => {
    //   state.codingAllocationCount.forAudited.loading = false;
    //   state.codingAllocationCount.forAudited.error = action.payload;
    // })
});

export const {} = codeWorkflowSlicer.actions;

export default codeWorkflowSlicer.reducer;